<script lang="ts" setup>
defineProps<{
  to: string
  title?: string
}>()
</script>
<template>
  <SidebarSection v-animate="{ animation: 'vertical-reveal' }">
    <h4 v-if="title" v-animate="{ animation: 'vertical-reveal' }">
      {{ title }}
    </h4>
    <NuxtLink class="text-small link-default" :to="to">
      <slot />
    </NuxtLink>
  </SidebarSection>
</template>
